module.exports = __webpack_public_path__ + "static/assets/3d3fd10378ca375044e174ceb0b82c7f.svg";